<div class="loading-index">
    <img ngSrc="{{ config.assetsUrl }}img/full-page-loader.png" alt="loading" priority="1" width="200" height="107"/>
    <div class="spinner">
        <div class="double-bounce1"></div>
        <div class="double-bounce2"></div>
    </div>
</div>
